import { render, staticRenderFns } from "./SideMenuMembers.vue?vue&type=template&id=79946f47&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79946f47')) {
      api.createRecord('79946f47', component.options)
    } else {
      api.reload('79946f47', component.options)
    }
    module.hot.accept("./SideMenuMembers.vue?vue&type=template&id=79946f47&", function () {
      api.rerender('79946f47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/SideMenuMembers.vue"
export default component.exports